var _this = this;
import * as tslib_1 from "tslib";
import { onSearchInputFocused } from '../actions/internalActions';
import { getSuggestions } from '../actions/publicActions';
import { getStore } from '../store/store';
import { lazySetIsFocusInSearchInput, lazyStartSearchSession } from 'owa-search';
import { orchestrator } from 'satcheljs';
export default orchestrator(onSearchInputFocused, function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var startSearchSession;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                lazySetIsFocusInSearchInput.importAndExecute(true /* isFocusInSearchInput */);
                if (!!getStore().searchSessionGuid) return [3 /*break*/, 2];
                return [4 /*yield*/, lazyStartSearchSession.import()];
            case 1:
                startSearchSession = _a.sent();
                startSearchSession('SearchBox', false /* shouldStartSearch */);
                return [3 /*break*/, 3];
            case 2:
                getSuggestions();
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}); });
//# sourceMappingURL=onSearchInputFocusedOrchestrator.js.map